export const rateOfChange = (arrayQuotes: any[]): any[] => {
  const roc = [];
  const quotesLength = arrayQuotes.length;

  for (let index = 0; index < quotesLength; index++) {
    if (index > 0) {
      roc.push(
        ((arrayQuotes[index].quote - arrayQuotes[index - 1].quote) /
          arrayQuotes[index - 1].quote) *
          100
      );
    }
  }

  return roc;
};

export const getStandardDeviation = (numArr: number[]): any => {
  return Math.sqrt(getVariance(numArr));
};

const getVariance = (numArr: number[]) => {
  const avg: any = getAverageFromNumArr(numArr);

  let i = numArr.length;
  let v: any = 0;

  while (i--) {
    v += Math.pow(numArr[i] - avg, 2);
  }

  v /= numArr.length;

  return v;
};

export const getAverageFromNumArr = (numArr: number[]) => {
  const arrAvg = numArr.reduce((a, b) => a + b) / numArr.length;

  return arrAvg;
};
